import RiskMapPage from '@/pages/RiskMapPage/RiskMapPage.vue'

export default RiskMapPage
